export default __webpack_public_path__ + "static/media/process-developer.173a5e75.svg";